import { Stack, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { RESPONSE_NO, RESPONSE_YES } from 'shared/constants';
import { CommoditySqlView } from 'shared/types';

export function BelowMarginFloorColumn(params: GridRenderCellParams<string, CommoditySqlView>) {
  const revisedMarginBelowFloor = Boolean(params.value);

  return (
    <Stack sx={revisedMarginBelowFloor ? { backgroundColor: 'red', color: 'white', borderRadius: '3px' } : {}}>
      <Typography sx={{ p: 1 }} variant='body2'>
        {revisedMarginBelowFloor ? RESPONSE_YES : RESPONSE_NO}
      </Typography>
    </Stack>
  );
}
